import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reportLatestFetch } from 'redux/actions/ReportActions';
import { Box, Typography } from '@material-ui/core';
import AppContext from '@jumbo/components/contextProvider/AppContextProvider/AppContext';
import IntlMessages from '@jumbo/utils/IntlMessages';
import _ from 'lodash';

const HeaderTitle = () => {
  const { locale } = useContext(AppContext);
  const dispatch = useDispatch();
  const authUser = useSelector(({ auth: { authUser } }) => authUser);
  const reportLatest = useSelector(({ report: { reportLatest } }) => reportLatest);
  const form = useSelector(({ form }) => form);
  const formValues = form.FilterForm ? form.FilterForm.values : null;
  console.log(reportLatest);

  useEffect(() => {
    dispatch(reportLatestFetch({}));
  }, [authUser]);

  return (
    <Box pl={2}>
      <Typography variant="h3" align="left">
        <IntlMessages id="summary-report.present" /> :{' '}
        {reportLatest && reportLatest.batch_txt && reportLatest.batch_txt[locale.locale]}
      </Typography>
      {!_.isEmpty(formValues) && (
        <Box pt={1}>
          <Typography variant="subtitle1" align="left" style={{ fontSize: 15 }}>
            {formValues.type && (
              <React.Fragment>
                <IntlMessages id={`filter.type.${formValues.type}`} /> -{' '}
              </React.Fragment>
            )}
            <IntlMessages id={`month`} />
            <IntlMessages id={`month.${formValues.month}`} /> <IntlMessages id={`year.${formValues.year}`} /> -{' '}
            <IntlMessages id={`filter.batch.${formValues.batch}`} /> -{' '}
            <IntlMessages id={`dealer.region.${formValues.dealer.region}`} /> -{' '}
            {formValues.dealer_code == 'all' ? (
              <IntlMessages id={`dealer.dealer_name.all`} />
            ) : (
              formValues.dealer_code.split('|')[1]
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default HeaderTitle;
